import React from "react";
import { oneOf } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Type of message */
  type: oneOf(["error", "help"]),
};

const CLASS_ROOT = "form-message";

const Message = ({ className, children, type, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${type}`]: type,
      "is-error": type === "error",
    },
    className
  );

  return (
    <p className={classes} {...other}>
      {children}
    </p>
  );
};

Message.displayName = "Message";
Message.propTypes = propTypes;

export default Message;
